import React from 'react';

export const DisplayError = ({errorMsg}) => {
    return (
        <div className="w3-container">
            <h4 className="w3-red"> <b> Oops found and error. Please see below.</b> </h4>
            <h5> ERROR: <b> {errorMsg ? errorMsg : "Not Found"}. </b> </h5>
       </div>
    )
}

export default DisplayError